<template>
  <div class="terms-of-use policy-page">
    <div class="container">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/' }">{{ $t('navigation.home') }}</el-breadcrumb-item>
        <el-breadcrumb-item>{{ $t('footer.termsOfUse') }}</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="go-back">
        <img @click="goBack" src="@/assets/icons/left.svg" alt="">
        <span @click="goBack">{{ $t('navigation.goBack') }}</span>
      </div>

      <!-- 中文版本 -->
      <div v-if="$i18n.locale === 'zh'" class="policy-content-zh">
        <div class="policy-header">
          <h1 class="main-title">服务条款</h1>
          <p class="effective-date">生效日期：2024/4/11</p>
          
          <h3 class="subsection-title">概述</h3>
          <p class="company-info">
            本服务条款适用于位于support.shokz.com/pop/index/cn及其各个子域（以下简称"网站"）的网站。该网站由深圳市韶音科技有限公司及其共同拥有和控制的关联实体（以下简称"Shokz"、"我们"、"我们的"或"我们"）运营。通过使用这些网站，您承认并同意此处列出的所有条款、条件、政策和通知（"服务条款"、"条款"）。如果您不同意这些条款，请不要使用这些网站。
          </p>
          <p class="intro-text">
            访问我们的网站即表示您使用了我们的"服务"，并同意接受本服务条款的约束。请注意，我们可能会不时更新本服务条款。请定期仔细检查这些条款和条件的变更。
          </p>
        </div>

        <div class="policy-section">
          <h2 class="section-title">第 1 节 一般条件</h2>
          <p class="section-content">
            同意本服务条款，即表示您至少已达到所在国家、州或省的法定年龄，或者您已达到所在国家、州或省的法定年龄，并已同意我们允许您的任何未成年家属使用本网站。
          </p>
          <p class="section-content">
            您不得将我们的某些手册和其他文件（"手册"）用于任何非法或未经授权的目的，也不得在使用服务时违反所在辖区的任何法律（包括但不限于版权法）。
          </p>
          <p class="section-content">
            不得传播任何蠕虫、病毒或任何破坏性代码。
          </p>
          <p class="section-content">
            违反或违反任何条款将导致立即终止您的服务。
          </p>
        </div>

        <div class="policy-section">
          <h2 class="section-title">第 2 节 网站的使用</h2>
          <p class="section-content">
            本网站提供标准陈列展架的介绍信息、安装说明和其他相关信息。您可以访问网站允许的任何手册，但仅限于在您的网络浏览器上查看手册供您个人使用。Shokz授权您在以下条件下使用手册：（1）您同意未经我们事先书面同意，不得复制、修改、再版、上传、张贴、传播或分发任何手册。如需请可，您可以联系<a href="mailto:customer.service@shokz.com" class="email-link">customer.service@shokz.com</a>所有手册均为Shokz的财产，可随时更新；（2）您同意仅将这些手册用于个人用途，不得用于任何其他未经授权的商业或非法用途；（3）您同意不删除网站和手册中的任何版权、商标或其他所有权标明。任何Shokz商标、标志、商业名称及任何其他用于识别服务或网站部分的标志均为本公司所有，不得用于Shokz所提供服务或产品以外的任何服务或产品，亦不得以任何可能导致客户产生混淆的方式使用，或以任何贬低或诋毁Shokz或损害Shokz声誉的方式使用。
          </p>
          <p class="section-content">
            网站上使用的所有软件均为本公司或第三方所有，除行使上述许可授权所需外，禁止对此类软件进行任何使用、再分发、销售、反汇编、翻译或以其他方式将其还原为人类可读形式。
          </p>
          <p class="section-content">
            您承认将按照所有适用的国家和国际法律、法规和规章使用网站。您承诺不破坏、修改或拦截网站或网站任何服务器上发布的信息，不试图规避网站的任何安全功能。
          </p>
        </div>

        <div class="policy-section">
          <h2 class="section-title">第 3 部分 信息的准确性、完整性和及时性</h2>
          <p class="section-content">
            如果网站上提供的信息不准确、不完整或不及时，我们概不负责。网站上的资料仅供一般参考，在未咨询更准确、更完整或更及时的主要信息来源的情况下，不应将其作为决策的唯一依据。任何对网站资料的依赖均由您自行承担风险。
          </p>
          <p class="section-content">
            网站可能包含某些历史信息。历史信息必然不是新信息，仅供您参考。我们保留随时修改网站内容的权利，但没有义务更新网站上的任何信息。您同意，您有责任关注对我们网站的变化。
          </p>
        </div>

        <div class="policy-section">
          <h2 class="section-title">第 4 节 所有权</h2>
          <p class="section-content">
            网站上发布的所有手册、文本、图形、版面设计、照片、商标、标识、声音、视频和所有其他内容（统称为"内容"）均为Shokz所有或被授权Shokz合理使用，并受不同国家的版权法、商标法和所有其他知识产权及不正当竞争法的保护。
          </p>
          <p class="section-content">
            您同意在使用网站服务的过程中保护 Shokz 和所有其他知识产权所有者的权利，并遵守 Shokz 或/和其他许可人的所有合理书面要求，或采取其他合理措施保护合同、法定和适用法律规定的权利持有人的权利。
          </p>
        </div>

        <div class="policy-section">
          <h2 class="section-title">第 5 部分 隐私声明</h2>
          <p class="section-content">
            我们的第三方服务提供商可能会使用 cookies、跟踪像素和其他类似技术。这些技术用于分析趋势、管理网站、跟踪用户在网站上的活动以及收集有关我们整个用户群的人口统计信息。我们不会主动查看第三方服务提供商收集的信息，但可能会根据第三方服务提供商对这些技术的使用情况收到报告，前提是这些报告已经脱敏。
          </p>
          <p class="section-content">
            如果您不希望使用 cookies，请向您的浏览器提供商咨询如何禁用 cookies。请注意，如果禁用所有 cookies，网站的某些功能可能无法使用。
          </p>
          <p class="section-content">
            网站可能包含指向其他网站的超链接或其他网站的嵌入内容。
          </p>
        </div>

        <div class="policy-section">
          <h2 class="section-title">第 6 节 免责声明；责任限制</h2>
          <p class="section-content">
            我们不会通过网站为任何情况提供具体建议。
          </p>
          <p class="section-content">
            我们不保证、声明或保证对我们服务的使用不会中断、及时、安全或没有错误。
          </p>
          <p class="section-content">
            您同意我们可能会不时无限期地取消服务，或在任何时候取消服务而不通知您。除我们明确说明外，通过网站提供的服务（除我们明确说明）是"按原样"和"按可用"提供给您使用的，没有任何形式的陈述、保证或条件，包括但不限于所有默示保证或适销性条件、特定用途的适销性质量、耐用性、所有权和非侵权性。在任何情况下，Shokz（包括我们的董事、高级职员、员工、关联公司、代理商、承包商、实习生、供应商、服务提供商或许可方）均不对任何伤害、损失、索赔或任何直接、间接、附带、惩罚性、特殊或后续性损害赔偿，包括但不限于利润损失、收入损失、储蓄损失、数据丢失、替换成本或任何类似损害，无论是基于合同、侵权行为（包括疏忽）、严格责任或其他方式，因您使用任何服务或因任何其他与网站使用有关的索赔，包括但不限于服务中的任何错误或遗漏，或因您或服务的任何其他索赔而造成的任何延迟、服务中断、病毒、文件删除或电子通讯，即使已被告知其可能性。由于某些州或司法管辖区不允许排除或限制后果性或附带损害赔偿，在这些州或司法管辖区，我们的责任应限于法律允许的最大范围。
          </p>
        </div>

        <div class="policy-section">
          <h2 class="section-title">第 7 节 赔偿</h2>
          <p class="section-content">
            对于任何第三方因您违反本服务条款，或因违反任何法律或第三方的权利提出的索赔或要求，包括合理的律师费，您同意对 Shokz 进行赔偿、为其辩护并使其免受损失。
          </p>
        </div>

        <div class="policy-section">
          <h2 class="section-title">第 8 节 可分割性</h2>
          <p class="section-content">
            如果本服务条款中的任何规定被认定为非法、无效或不可执行，则该规定仍应在适用法律允许的最大范围内执行，且不可执行部分应视为已从本服务条款中分离，该认定不应影响任何其他剩余条款的有效性和可执行性。
          </p>
        </div>

        <div class="policy-section">
          <h2 class="section-title">第 9 节 完整协议</h2>
          <p class="section-content">
            我们未能行使或执行本服务条款的任何权利或规定不构成对该权利或规定的放弃。
          </p>
          <p class="section-content">
            本服务条款以及我们在本网站上发布的或与本服务相关的任何政策或操作规则构成您与我们之间的完整协议和谅解，并管理您对本服务的使用，取代我们与您之间先前或同时达成的任何口头或书面协议。通信和建议（包括但不限于本服务条款的任何先前版本）。对本服务条款的解释中的任何歧义不得针对起草方进行解释。
          </p>
        </div>

        <div class="policy-section">
          <h2 class="section-title">第 10 节 管辖法律</h2>
          <p class="section-content">
            本网站由 Shokz 控制，可在全球大多数国家访问。在使用本网站时，您和 Shokz 同意所有因使用和操作本网站而引起的或与使用和操作本网站有关的事宜，均受中华人民共和国法律管辖，而不考虑其法律冲突原则。由于您所在地的法律可能与中华人民共和国的法律不同，您承认因您在所在地使用或其他利用本网站而产生的或与之有关的所有有争端将在深圳国际仲裁院（或称SCIA）审理和解决。您同意SCIA对您拥有属人管辖权，并承诺不对该管辖权提出任何异议。
          </p>
        </div>

        <div class="policy-section">
          <h2 class="section-title">第 11 节 服务条款的变更</h2>
          <p class="section-content">
            您可以随时在此页面查看最新版本的服务条款。
          </p>
          <p class="section-content">
            我们保留随时在我们的网站上发布新版本或变更，自行决定更新、变更或替换本服务条款任何部分的权利。您有责任定期查看我们的网站上的变更。在本服务条款发布任何变更后，如果您继续使用或访问我们的网站或服务，即表示您接受这些变更。
          </p>
        </div>

        <div class="policy-section">
          <h2 class="section-title">第 12 部分 联系信息</h2>
          <p class="section-content">
            有关服务条款的问题，请发送电子邮件至 <a href="mailto:customer.service@shokz.com" class="email-link">customer.service@shokz.com</a>。
          </p>
        </div>
      </div>

      <!-- 英文版本 -->
      <div v-else class="policy-content-en">
        <div class="policy-header">
          <h1 class="main-title">TERMS OF SERVICE</h1>
          <p class="effective-date">Effective Date: 2024/4/11</p>
          
          <h3 class="subsection-title">OVERVIEW</h3>
          <p class="company-info">
            This Terms of Service applies to the website located at support.shokz.com/pop/index/cn and its various sub-domains ("Sites"), which is operated by Shenzhen Shokz Co., Ltd and its affiliated entities under common ownership and control (referred to as "Shokz", "we", "our" or "us"). By using these Sites, you acknowledge and agree to all terms, conditions, policies and notices stated here ("Terms of Service", "Terms"). IF YOU DO NOT AGREE TO THE TERMS, PLEASE DO NOT USE THE SITES.
          </p>
          <p class="intro-text">
            By visiting our Sites, you engage in our "Services" and agree to be bound by this Terms of Service. Please note we may update this Terms of Service from time to time. PLEASE CHECK THESE TERMS AND CONDITIONS CAREFULLY AND PERIODICALLY FOR CHANGES.
          </p>
        </div>

        <div class="policy-section">
          <h2 class="section-title">SECTION 1 - GENERAL CONDITIONS</h2>
          <p class="section-content">
            By agreeing to these Terms of Service, you represent that you are at least the age of majority in your country, state or province of residence, or that you are the age of majority in your country, state or province of residence and you have given us your consent to allow any of your minor dependents to use the Sites.
          </p>
          <p class="section-content">
            You may not use our certain manuals and other documents ("Manuals") for any illegal or unauthorized purpose nor may you, in the use of the Services, violate any laws in your jurisdiction (including but not limited to copyright laws).
          </p>
          <p class="section-content">
            You must not transmit any worms or viruses or any code of a destructive nature.
          </p>
          <p class="section-content">
            A breach or violation of any of the Terms will result in an immediate termination of your Services.
          </p>
        </div>

        <div class="policy-section">
          <h2 class="section-title">SECTION 2 – USE OF THE SITES</h2>
          <p class="section-content">
            The Sites provide introduction information, installation instructions, and other relevant information for our Standard Displays. You may access any Manual as permitted by the Sites only as required to view the Manuals on your web browser for your individual use. Shokz authorizes you to use Manuals subject to the following conditions: (1) You agree not to copy, modify, republish, upload, post, transmit or distribute any Manuals without our prior written consent. To request permission, you may contact <a href="mailto:customer.service@shokz.com" class="email-link">customer.service@shokz.com</a>. All Manuals are the property of Shokz and may be updated at any time; (2) You agree to use these Manuals for your personal use only and not for any other unauthorized commercial or illegal use; (3) You agree not to remove any copyright, trademark, or other proprietary notices that have been placed in the Sites and Manuals.
          </p>
          <p class="section-content">
            Any Shokz trademarks, marks, trade names and any other marks used to identify Services or sections of the Sites are proprietary to us, and they may not be used in connection with any other service or products other than those provided by Shokz, in any manner that is likely to cause confusion among customers, or in any manner that disparages or discredits Shokz.
          </p>
          <p class="section-content">
            All software used on the Sites is proprietary to us or to third parties, and except as may be required to exercise the foregoing license grant, any use, redistribution, sale, de-compilation, reverse engineering, disassembly, translation or other reduction of such software to human-readable form is prohibited.
          </p>
          <p class="section-content">
            You acknowledge that you will use Sites in accordance with all applicable, national and international laws, rules and regulations. You commit not to disrupt, modify or intercept information posted on Sites or any server on Sites and not to attempt to circumvent any of the security features of Sites.
          </p>
        </div>

        <div class="policy-section">
          <h2 class="section-title">SECTION 3 - ACCURACY, COMPLETENESS AND TIMELINESS OF INFORMATION</h2>
          <p class="section-content">
            We are not responsible if information made available on the Sites is not accurate, complete or current. The material on the Sites is provided for general information only and should not be relied upon or used as the sole basis for making decisions without consulting primary, more accurate, more complete or more timely sources of information. Any reliance on the material on the Sites is at your own risk.
          </p>
          <p class="section-content">
            The Sites may contain certain historical information. Historical information, necessarily, is not current and is provided for your reference only. We reserve the right to modify the contents of the Sites at any time, but we have no obligation to update any information on our Sites. You agree that it is your responsibility to monitor changes to our Sites.
          </p>
        </div>

        <div class="policy-section">
          <h2 class="section-title">SECTION 4 - OUR PROPRIETARY RIGHTS</h2>
          <p class="section-content">
            All Manuals, text, graphics, layout designs, photographs, trademarks, logos, sounds, videos and all other content published on the Sites (collectively, the "Content") are owned by or licensed to Shokz for fair use and are protected by copyright laws, trademark laws and all other intellectual property rights and unfair competition laws in different countries.
          </p>
          <p class="section-content">
            You agree to protect the rights of Shokz and all other owners of intellectual property rights in the course of using the Services on the Sites, and to comply with all reasonable written requests by Shokz or/and other licensors, or to take other reasonable measures to protect the rights of rights holders under contract, statutory and applicable laws.
          </p>
        </div>

        <div class="policy-section">
          <h2 class="section-title">SECTION 5 – PRIVACY STATEMENT</h2>
          <p class="section-content">
            Our third-party service providers may use cookies, tracking pixels and other similar technologies. These technologies are used to analyze trends, administer the Sites, track user activity on the Sites, and gather demographic information about our entire user base. We do not actively look at the information collected by third-party service providers, but may receive reports based on the use of these technologies by Our third-party service providers, provided that the reports will be desensitized.
          </p>
          <p class="section-content">
            If you would prefer not to use cookies, please check with your browser provider on how to disable cookies. Please note that some features of the Sites may not work if all cookies are disabled.
          </p>
          <p class="section-content">
            The Sites may contain hyperlinks to other websites, or embedded content of other websites.
          </p>
        </div>

        <div class="policy-section">
          <h2 class="section-title">SECTION 6 –DISCLAIMERS; LIMITATION OF LIABILITY</h2>
          <p class="section-content">
            We are not, by means of our Sites, providing specific recommendations for any situation or circumstance.
          </p>
          <p class="section-content">
            We do not guarantee, represent or warrant that your use of our Services will be uninterrupted, timely, secure or error-free.
          </p>
          <p class="section-content">
            You agree that from time to time we may remove the Services for indefinite periods of time or cancel the Services at any time, without notice to you. The Services delivered to you through the Sites are (except as expressly stated by us) provided 'as is' and 'as available' for your use, without any representation, warranties or conditions of any kind, either express or implied, including all implied warranties or conditions of merchantability, merchantable quality, fitness for a particular purpose, durability, title, and non-infringement. In no case shall Shokz, including our directors, officers, employees, affiliates, agents, contractors, interns, suppliers, service providers or licensors be liable for any injury, loss, claim, or any direct, indirect, incidental, punitive, special, or consequential damages of any kind, including, without limitation lost profits, lost revenue, lost savings, loss of data, replacement costs, or any similar damages, whether based in contract, tort (including negligence), strict liability or otherwise, arising from your use of any of the Services, or for any other claim related in any way to your use of the Services, including, but not limited to, any errors or omissions in any content, or any loss or damage resulting from delay, interruption in service, viruses, deletion of files or electronic communications, even if advised of their possibility. Because some states or jurisdictions do not allow the exclusion or the limitation of liability for consequential or incidental damages, in such states or jurisdictions, our liability shall be limited to the maximum extent permitted by law.
          </p>
        </div>

        <div class="policy-section">
          <h2 class="section-title">SECTION 7 - INDEMNIFICATION</h2>
          <p class="section-content">
            You agree to indemnify, defend and hold harmless Shokz from and against any claim or demand, including reasonable attorneys' fees, made by any third-party due to or arising out of your breach of these Terms of Service, or your violation of any law or the rights of a third-party.
          </p>
        </div>

        <div class="policy-section">
          <h2 class="section-title">SECTION 8 - SEVERABILITY</h2>
          <p class="section-content">
            In the event that any provision of these Terms of Service is determined to be unlawful, void or unenforceable, such provision shall nonetheless be enforceable to the fullest extent permitted by applicable law, and the unenforceable portion shall be deemed to be severed from these Terms of Service, such determination shall not affect the validity and enforceability of any other remaining provisions.
          </p>
        </div>

        <div class="policy-section">
          <h2 class="section-title">SECTION 9 - ENTIRE AGREEMENT</h2>
          <p class="section-content">
            The failure of us to exercise or enforce any right or provision of these Terms of Service shall not constitute a waiver of such right or provision.
          </p>
          <p class="section-content">
            These Terms of Service and any policies or operating rules posted by us on this site or in respect to the Service constitutes the entire agreement and understanding between you and us and govern your use of the Services, superseding any prior or contemporaneous agreements, communications and proposals, whether oral or written, between you and us (including, but not limited to, any prior versions of the Terms of Service). Any ambiguities in the interpretation of these Terms of Service shall not be construed against the drafting party.
          </p>
        </div>

        <div class="policy-section">
          <h2 class="section-title">SECTION 10 - GOVERNING LAW</h2>
          <p class="section-content">
            The Sites are controlled by Shokz and can be accessed in most countries on a worldwide basis. By using the Sites, you and Shokz agree that all matters arising out of or relating to the use and operation of the Sites will be governed by the laws of China, without regard to its conflict of laws principles. Because the laws of your location may differ from the laws of China, you will be responsible for compliance with all local laws of your domicile. You agree that all disputes that you may have arising from your use, operation, and other exploitation of the Sites will be heard and resolved at the Shenzhen Court of International Arbitration (the SCIA). You consent to the personal jurisdiction of the SCIA over you, to the fairness and convenience of proceedings before the SCIA and undertake not to raise any objection to jurisdiction.
          </p>
        </div>

        <div class="policy-section">
          <h2 class="section-title">SECTION 11 - CHANGES TO TERMS OF SERVICE</h2>
          <p class="section-content">
            You can review the most current version of the Terms of Service at any time at this page.
          </p>
          <p class="section-content">
            We reserve the right, at our sole discretion, to update, change or replace any part of these Terms of Service by posting updates and changes to our Sites. It is your responsibility to check our Sites periodically for changes. Your continued use of or access to our Sites or the Services following the posting of any changes to these Terms of Service constitutes acceptance of those changes.
          </p>
        </div>

        <div class="policy-section">
          <h2 class="section-title">SECTION 12 - CONTACT INFORMATION</h2>
          <p class="section-content">
            Questions about the Terms of Service should be sent to us at <a href="mailto:customer.service@shokz.com" class="email-link">customer.service@shokz.com</a>.
          </p>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  name: 'TermsOfUse',
  methods: {
    goBack() {
      this.$router.push({ path: '/' });
    }
  }
}
</script>

<style lang='scss' scoped>
</style>